import React, { Component } from 'react';
import './Collage.css';
import EditBar from '../EditBar/EditBar';
import { Image, Picture } from 'pixboost-react';
import pixboostConfig from '../../../config/pixboost';
import Cta from '../Cta/Cta';
import classNames from 'classnames';

class Collage extends Component {
  toggleEditing(toggle) {
    if (this.props.onToggleEditing) {
      this.props.onToggleEditing(toggle);
    }
  }

  render() {
    const {
      title,
      image,
      imageBasePath,
      link,
      links,
      backgroundColour,
      buttonText,
      sectionIndex,
      contentBlockIndex,
      removeContentBlock,
      ctaPosition,
      ctaMobilePosition,
      isResponsiveImage,
      description,
      titleFontSize,
      className,
      linkTag
    } = this.props;

    const classes = classNames(
      className,
      {
        [backgroundColour]: backgroundColour
      },
      'edit-wrapper'
    );

    return (
      <div>
        <div className={classes}>
          <div>
            <Cta
              title={title}
              buttonText={buttonText}
              ctaPosition={ctaPosition}
              ctaMobilePosition={ctaMobilePosition}
              link={link}
              description={description}
              titleFontSize={titleFontSize}
              links={links}
              linkTag={linkTag}
            />
          </div>
          {image && (
            <div>
              <div className="image">
                {isResponsiveImage ? (
                  <Picture
                    alt={title}
                    breakpoints={{
                      lg: {
                        src: imageBasePath + image.lg
                      },
                      md: {
                        src: imageBasePath + image.md
                      },
                      sm: {
                        src: imageBasePath + image.sm
                      }
                    }}
                    config={pixboostConfig}
                    lazy={false}
                  />
                ) : (
                  <Image
                    src={imageBasePath + image}
                    alt={title}
                    config={pixboostConfig}
                    op={'resize?size=x400'}
                    lazy={false}
                  />
                )}
              </div>
            </div>
          )}
          <EditBar
            toggleEditing={() => this.toggleEditing(true)}
            removeContentBlock={() =>
              removeContentBlock(sectionIndex, contentBlockIndex)
            }
          />
        </div>
      </div>
    );
  }
}

export default Collage;



// WEBPACK FOOTER //
// ./src/components/landingPage/Collage/Collage.js